<template>
  <!-- 订单页 -->
  <div>
    <!-- <top-bar></top-bar> -->
    <div class="orders main">
      <!-- <div class="logos main">
        <div class="logo-img">
          <img src="../../assets/imgs/logo.png" width="200" />
        </div>
        <div class="steps-box">
          <a-steps :current="current">
            <a-step>
              <template slot="title">我的购物车</template>
            </a-step>
            <a-step title="确认订单" />
            <a-step title="提交订单" />
          </a-steps>
        </div>
      </div>-->
      <div class="check-info">填写并核对订单信息</div>
      <a-card>
        <div class="consignee">
          <span>收货人信息</span>
          <a @click="addressModal = true">新增收货地址</a>
        </div>
        <ul class="consignee-info" ref="consigneeInfo">
          <li v-for="(item, index) in addressList" :key="index">
            <span
              :class="activeIndex === index ? 'choosed-active' : 'choosed'"
              @click="
                activeIndex = index;
                (addressId = item.id), getfreightMoney();
              "
              >{{ item.name }}</span
            >
            <span class="name">{{ item.name }}</span>
            <span class="address">{{ item.addDetail }} {{ item.detail }}</span>
            <span class="phone">{{ item.phone }}</span>
            <span class="default-state" v-if="item.defAdr">默认地址</span>
            <span class="set-default" v-else>
              <a href="#" @click="setDef(item.id)">设为默认地址</a>
            </span>
          </li>
        </ul>
        <a tag="div" class="more-address" @click="moreAddress" v-if="!moreAddr">展开地址</a>
        <a tag="div" class="more-address" @click="lessAddress" v-else>收起地址</a>
        <div class="payment-way">支付方式</div>
        <div class="payment-choosed">
          <span :class="payChoosed === 'onlinePayment' ? 'pay-active' : 'pay-default'" @click="payChoosed = 'onlinePayment'"
            >在线支付</span
          >
          <span
            v-if="userInfo.schoolType != 'STUDENT' && userInfo.schoolType != 'OTHER'"
            :class="payChoosed === 'deliveryPayment' ? 'pay-active' : 'pay-default'"
            @click="payChoosed = 'deliveryPayment'"
            >线下付款</span
          >
        </div>
        <div class="goods-list">货物清单</div>
        <a-table :columns="goodsColumns" :dataSource="goodsData" :showHeader="false" rowKey="productId" :pagination="false">
          <template slot="name" slot-scope="text, record">
            <img :src="getPhoto(record.pic)" width="50px" height="50px" />
            <span style="margin: 0 20px 0 20px;">{{ text }}</span>
            <span v-if="record.value"
              >(规格: <span style="color:#e69b47">{{ record.value }}</span
              >)</span
            >
          </template>
          <template slot="unitPrice" slot-scope="text">
            <span style="color: red;">￥{{ numberFormat(text) }}</span>
          </template>
          <template slot="num" slot-scope="text">
            <span>{{ text }}件</span>
          </template>
          <template slot="totalMoney" slot-scope="text, record">
            <span style="color: red;">￥{{ numberFormat(record.unitPrice * record.num) }}</span>
          </template>
        </a-table>
        <div class="invoice mt10">
          <span>发票信息</span>
          <a style="float: right;" @click="invoiceModal = true">新增</a>
        </div>
        <div class="invoice-box">
          <a-radio-group v-model="valueRadio" @change="onChange">
            <a-radio :style="radioStyle" v-for="item in invoiceList" :key="item.name" :value="`${item.name},${item.tin}`">
              <span class="invoice-type">普通发票</span>
              <span class="invoice-rise">{{ item.name }}</span>
              <span class="invoice-content">商品明细</span>
              <a-popconfirm title="确认删除该条发票信息吗？" @confirm="confirm(item.id)" okText="确定" cancelText="取消">
                <a href="#" v-if="item.name !== '个人'">删除</a>
              </a-popconfirm>
            </a-radio>
          </a-radio-group>
          <!-- <div v-for="item in invoiceList" :key="item.name">
            <span class="invoice-type">普通发票</span>
            <span class="invoice-rise">{{item.name}}</span>
            <span class="invoice-content">商品明细</span>
          </div>-->
        </div>
        <div class="invoice mt10">
          <span>订单备注</span>
          <a-textarea v-model="remark" placeholder="可输入订单备注信息，字数不可超过150" :rows="4" style="resize: none;" />
        </div>
      </a-card>
      <div class="orders-detail">
        <div class="price-product">
          <span>商品总额：</span>
          <span>￥{{ numberFormat(totalMoney) }}</span>
        </div>
        <div class="price-freight">
          <span>运费：</span>
          <span>￥{{ numberFormat(freightMoney) }}</span>
        </div>
        <div class="price-tatol">
          <span>应付总价：</span>
          <span>￥{{ numberFormat(totalMoney + freightMoney) }}</span>
        </div>
      </div>
      <div class="pay-money">
        <router-link :to="`/shoppingCart`">返回购物车</router-link>
        <span class="submit-orders" @click="submitOrders(payChoosed)">提交订单</span>
      </div>
    </div>
    <!-- <foot-bar></foot-bar> -->
    <a-modal title="新增地址" :visible="addressModal" :confirmLoading="confirmLoading" @cancel="addressModal = false">
      <a-form :form="form">
        <a-form-item label="地址信息" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
          <!-- <a-cascader :options="options" @change="onChange" placeholder="Please select" /> -->
          <expertAddress @addressChange="addressChange" />
        </a-form-item>
        <a-form-item label="详细地址" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
          <a-textarea
            v-decorator="['detail', { rules: [{ required: true, message: '请输入详细地址。' }] }]"
            :rows="3"
            placeholder="请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元号等信息"
          ></a-textarea>
        </a-form-item>
        <a-form-item label="邮政编码" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
          <a-input
            v-decorator="['zip', { rules: [] }]"
            placeholder="请输入邮政编码"
          />
        </a-form-item>
        <a-form-item label="收货人姓名" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
          <a-input
            v-decorator="['name', { rules: [{ required: true, message: '长度不能超过25个字符' }] }]"
            placeholder="长度不能超过25个字符"
          />
        </a-form-item>
        <a-form-item label="手机号码" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
          <a-input
            v-decorator="['phone', { rules: [{ required: true, message: '电话号码、手机号码必须填一项' }] }]"
            placeholder="电话号码、手机号码必须填一项"
          />
        </a-form-item>
        <a-form-item>
          <a-checkbox checked @change="defAdrChange">设置为默认收货地址</a-checkbox>
        </a-form-item>
      </a-form>
      <div slot="footer">
        <a-button class="mr20" type="primary" @click="saveAddress">保存</a-button>
        <a-button @click="addressModal = false">取消</a-button>
      </div>
    </a-modal>
    <!-- 发票弹出框 -->
    <a-modal title="发票信息" :visible="invoiceModal" @ok="handleOk" @cancel="invoiceModal = false">
      <a-form :form="invoiceForm">
        <a-form-item label="发票类型" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
          <span>普通发票</span>
        </a-form-item>
        <a-form-item label="发票抬头" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
          <a-input v-decorator="['name']" placeholder="填写公司名字" />
        </a-form-item>
        <a-form-item label="税号" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
          <a-input v-decorator="['tin']" placeholder="请填写公司的税号" />
        </a-form-item>
        <!-- <a-form-item
          label="纳税人识别号"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 17 }"
          v-show="invoiceInfo.invoiceContent === '2'"
        >
          <a-input v-decorator="['tin',{ initialValue:  invoiceInfo.tin}]" placeholder="纳税人识别号" />
        </a-form-item>-->
        <a-form-item label="发票内容" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
          <span>发票明细</span>
          <!-- <a-radio-group
            @change="invoiceContentChange"
            v-decorator="['invoiceContent', {initialValue:  invoiceInfo.invoiceContent}]"
          >
            <a-radio-button :value="'1'">商品明细</a-radio-button>
            <a-radio-button :value="'2'">类别</a-radio-button>
          </a-radio-group>-->
          <p v-show="invoiceInfo.invoiceContent === '1'">发票内容将显示详细商品名称与价格信息</p>
          <!-- <p v-show="invoiceInfo.invoiceContent === '2'">发票内容将显示详细商品所属类别与价格信息</p> -->
        </a-form-item>
      </a-form>
      <div slot="footer">
        <a-button class="mr20" type="primary" @click="saveInvoice">保存</a-button>
        <a-button @click="invoiceModal = false">取消</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
// import topBar from '@/layouts/sideBar/topBar'
// import footBar from '@/layouts/sideBar/footBar'
import expertAddress from '@/components/expertAddress/expertAddress.vue'
import { getAddresses, modifyAddressDef, addAddress } from '@/serve/addresses'
import { getInvoice, addInvoice, delInvoice } from '@/serve/invoice' // addInvoice
import { getfreight } from '@/serve/payments'
import { shopSkusDetail, shopSkusList } from '@/serve/shop'
import { getShopCarts } from '@/serve/shopCars'
import { regionsDetail } from '@/serve/regions'
import { postOrder } from '@/serve/orders'
import { mixinFormat } from '@/mixins/mixin'
import global from 'global'
import { mapGetters } from 'vuex'
export default {
  name: 'orders',
  components: {
    // topBar,
    // footBar
    expertAddress
  },
  mixins: [mixinFormat],
  computed: {
    ...mapGetters(['userInfo'])
  },
  data () {
    return {
      remark: '', // 订单备注
      form: this.$form.createForm(this),
      invoiceForm: this.$form.createForm(this),
      storeId: this.$route.query.storeId || '',
      current: 1,
      skuId: '',
      num: 1, // 数量
      freightMoney: 0, // 运费
      params: {
        products: '',
        regionId: ''
      },
      payChoosed: 'onlinePayment', // 支付方式
      addressId: '', // 收货地址Id
      addressList: [], // 获取收货地址列表
      regionDetail: '', // 收货区域
      activeIndex: 0, // 收货地址激活项
      addressCode: '', // 新增地址code
      defAdr: true, // 是否是默认地址
      goodsColumns: [
        {
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' }
        },
        {
          dataIndex: 'unitPrice',
          scopedSlots: { customRender: 'unitPrice' }
        },
        {
          dataIndex: 'num',
          scopedSlots: { customRender: 'num' }
        },
        {
          dataIndex: 'totalMoney',
          scopedSlots: { customRender: 'totalMoney' }
        }
      ],
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      },
      goodsData: [], // 获取清单
      addressModal: false, // 新增地址弹出框
      invoiceModal: false, // 发票信息弹出框
      totalMoney: 0, // 总金额
      confirmLoading: false,
      invoiceInfo: {
        name: '个人',
        tin: ''
      },
      invoiceList: [],
      submitInvoice: {
        invName: '个人',
        invTin: ''
      }, // 提交时发票信息
      moreAddr: false,
      add: [],
      valueRadio: '个人,'
    }
  },
  watch: {
    freightMoney: {
      handler (newVal, oldVal) {
        if (newVal >= oldVal) {
          this.freightMoney = newVal
        }
      }
    }
  },
  methods: {
    // 获取运费
    getfreightMoney () {
      // 获取运费
      let arr = []
      this.goodsData.forEach(item => {
        arr.push({
          num: parseInt(item.num),
          sku: item.skuId
        })
      })
      this.params.products = arr
      this.params.regionId = this.addressId
      getfreight(this.params).then(res => {
        this.freightMoney = res.price
      })
    },
    // 获取图片
    getPhoto (pics) {
      let arr = pics.split(',')
      return global.file.url + '/sys/fs/' + arr[0] + '?s=1'
    },
    // 设置为默认地址
    setDef (id) {
      modifyAddressDef(id)
        .then(res => {
          this.$message.success('设置成功')
          this.getAddresses()
        })
        .catch(() => {
          this.$message.error('设置失败')
        })
    },
    addressChange (val) {
      let temp = []
      val.forEach(item => {
        temp.push(item.value)
      })
      // this.addressCode = temp.join(',')
      this.addressCode = temp[temp.length - 1]
    },
    // 是否默认收货地址
    defAdrChange (val) {
      this.defAdr = val
    },
    // 更多地址
    moreAddress () {
      this.moreAddr = true
      let len = this.addressList.length
      this.$refs.consigneeInfo.style.maxHeight = len * 60 + 'px'
    },
    lessAddress () {
      this.moreAddr = false
      this.$refs.consigneeInfo.style.maxHeight = '60px'
    },
    // 新增保存地址信息
    saveAddress (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          values.email = ''
          values.regionId = this.addressCode // 地址Code
          values.defAdr = this.defAdr // 是否默认地址
          addAddress(values)
            .then(res => {
              this.getAddresses()
              this.addressModal = false
              this.$message.success('添加成功')
            })
            .catch(() => {
              this.$message.error('添加失败，请稍后重试')
            })
        }
      })
    },
    // 保存发票信息
    saveInvoice (e) {
      this.invoiceForm.validateFields((err, values) => {
        if (!err) {
          addInvoice(values)
            .then(res => {
              this.getInvoice()
              this.$message.success('新增成功')
              this.invoiceModal = false
            })
            .catch(() => {
              this.$message.error('新增失败，请稍后重试')
            })
        }
      })
    },
    // 删除发票信息
    confirm (id) {
      delInvoice(id)
        .then(res => {
          this.$message.success('删除成功')
          this.getInvoice()
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },
    handleOk () {
      this.addressModal = false
    },
    onChange (value) {
      let temp = value.target.value.split(',')
      console.log(temp, '改变')
      this.submitInvoice = {
        invName: temp[0],
        invTin: temp[1]
      }
    },
    // 提交订单
    submitOrders (payChoosed) {
      if (!this.submitInvoice.invName) {
        this.$message.error('请选择发票信息')
        return
      }
      let tempArr = this.valueRadio.split(',')
      let params = {
        remark: this.remark,
        addressId: this.addressId, // 收货地址Id
        payTypeCode: this.payChoosed, // 支付类型Code
        transportPrice: this.freightMoney, // 运费
        products: [], // 商品信息
        invName: this.submitInvoice.invName || tempArr[0], // 抬头：个人或者公司名称
        invTin: this.submitInvoice.invTin // 税号（只有抬头是公司的时候需要）
      }
      this.goodsData.forEach(item => {
        // console.log('item.shoperType', item.shoperType)
        // console.log('this.userInfo.type', this.userInfo.type)
        // if (item.shoperType.indexOf(this.userInfo.type) === -1) {
        //   this.$message.error(`${item.name}不支持该用户购买，如有需要请联系管理员。`)
        //   return
        // }
        params.products.push({
          num: item.num,
          sku: item.skuId,
          unitPrice: item.unitPrice
        })
      })
      postOrder(params)
        .then(res => {
          this.$router.push({ path: '/payOrders', query: { type: payChoosed, id: res.id } })
        })
        .catch(err => {
          if (err.data.code == 'FAIL_PARAM') {
            this.$message.error('收货人信息不能为空！')
          } else {
            this.$message.error(err.data.message || '提交订单失败，请稍后再试')
          }
        })
    },
    // 选择发票内容
    invoiceContentChange(e) {
      this.invoiceInfo.invoiceContent = e.target.value.toString()
    },
    // 获取批量收货地址
    getAddresses() {
      getAddresses().then(res => {
        for (let i = 0; i < res.length; i++) {
          this.getAddressesDetail(res[i].regionId).then(res1 => {
            this.$set(res[i], 'addDetail', res1)
          })
        }
        this.addressList = res
        this.addressId = res[0].id
        // 获取运费信息
        this.getfreightMoney()
      })
    },
    // 获取地址详情
    async getAddressesDetail (id) {
      let asd = ''
      await regionsDetail(id).then(res => {
        this.add = []
        asd = this.getAdd(res)
      })
      return asd
    },
    getAdd (aa) {
      this.add.push(aa.name)
      if (aa.parentRegion) {
        this.getAdd(aa.parentRegion)
      }
      let temp = this.add.reverse()
      return temp.join('')
    },
    /* // 获取地址详情
    getRegions (id) {
      let regionDetail = ''
      regionsDetail(id).then(res => {
        regionDetail = res.name
        if (res.parentRegion) {
          regionDetail = res.parentRegion.name + regionDetail
          if (res.parentRegion.parentRegion) {
            regionDetail = res.parentRegion.parentRegion.name + regionDetail
          }
        }
        return '7878787'
      })
    }, */
    // 获取货物清单
    getGoodsList () {
      getShopCarts({ checked: true, storeId: this.storeId }).then(res => {
        let skus = res.map(item => item.skuId).join(',')
        shopSkusList({ skus }).then(data => {
          res.forEach(item => {
            data.forEach(good => {
              if (good.sku === item.skuId) {
                item.value = good.productPropertyList[0].value
                item.pic = good.pic
                item.name = good.name
                item.storeName = good.storeName
                item.shoperType = good.shoperType
              }
            })
          })
          res.forEach(item => {
            this.totalMoney += item.num * item.unitPrice
            this.goodsData.push(item)
          })
          this.getAddresses()
        })
      })
    },
    // 获取商品规格
    getGoodsSkus (goods) {
      let skus = goods.map(item => item.skuId).join(',')
      shopSkusList({ skus }).then(res => {
        goods.forEach(good => {
          res.forEach(item => {
            if (item.sku === good.skuId) {
              good.value = item.productPropertyList[0].value
            }
          })
        })
      })
    },
    buyNow () {
      let params = {}
      shopSkusDetail(this.skuId).then(res1 => {
        params.shoperType = res1.shoperType
        params.pic = res1.pic
        params.name = res1.name
        params.num = this.num
        params.skuId = this.skuId
        params.unitPrice = res1.unitPrice
        params.stroeName = res1.stroeName
        this.goodsData.push(params)
        this.totalMoney = this.num * res1.unitPrice
        this.getAddresses()
      })
    },
    // 获取发票信息
    getInvoice () {
      getInvoice().then(res => {
        this.invoiceList = res
        this.invoiceList.unshift(this.invoiceInfo)
        console.log(this.invoiceList, '信息')
      })
    }
  },
  created () {
    this.skuId = this.$route.query.skuId
    this.num = this.$route.query.num
    if (this.skuId) {
      this.buyNow()
    } else {
      this.getGoodsList()
    }
    // 获取发票信息
    this.getInvoice()
  }
}
</script>

<style lang="less" scoped>
.orders {
  .logos {
    display: flex;
    justify-content: space-between;

    .steps-box {
      width: 500px;
    }
  }
  .check-info {
    font-size: 20px;
    line-height: 80px;
  }

  .consignee {
    line-height: 40px;
    display: flex;
    justify-content: space-between;
    span {
      font-size: 20px;
      font-weight: 700;
    }
  }
  .consignee-info {
    padding-left: 0;
    margin: 0;
    max-height: 60px;
    overflow: hidden;
    li {
      line-height: 60px;
      span {
        margin-right: 20px;
      }
      /* .choosed {
        padding: 10px 40px;
        border: 3px solid #ccc;
        cursor: pointer;
      }
      .choosed-active {
        padding: 10px 40px;
        border: 3px solid #E69B47;
        cursor: pointer;
        position: relative;
        &::after {
          position: absolute;
          right: 0;
          bottom: 0;
          content: "";
          width: 0;
          height: 0;
          border-width: 0 0 20px 20px;
          border-style: solid;
          border-color: transparent transparent #E69B47;
        }
      } */
      .default-state {
        background: #ccc;
        padding: 5px 10px;
        color: #fff;
      }
    }
  }

  .more-address {
    line-height: 50px;
    border-bottom: 1px solid #ccc;
  }

  // 支付方式
  .payment-way,
  .goods-list,
  .invoice span {
    line-height: 40px;
    font-size: 20px;
    font-weight: 700;
  }

  .payment-choosed {
    line-height: 60px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 30px;
    span {
      margin-right: 20px;
    }
  }
  .choosed,
  .pay-default {
    padding: 10px 40px;
    border: 3px solid #ccc;
    cursor: pointer;
  }
  .choosed-active,
  .pay-active {
    padding: 10px 40px;
    border: 3px solid #e69b47;
    cursor: pointer;
    position: relative;
    &::after {
      position: absolute;
      right: 0;
      bottom: 0;
      content: "";
      width: 0;
      height: 0;
      border-width: 0 0 20px 20px;
      border-style: solid;
      border-color: transparent transparent #e69b47;
    }
  }
  .invoice-box {
    line-height: 60px;
    span {
      margin-right: 20px;
    }
  }

  .orders-detail {
    padding: 20px 0;
    div {
      margin-bottom: 10px;
      text-align: right;

      span {
        display: inline-block;
        &:nth-child(2) {
          width: 150px;
        }
      }
    }
    .price-product,
    .price-freight {
      span {
        &:nth-child(2) {
          font-weight: 700;
        }
      }
    }
    .price-tatol {
      span {
        &:nth-child(2) {
          font-weight: 700;
          font-size: 24px;
          color: red;
        }
      }
    }
  }

  .pay-money {
    text-align: right;
    border: 1px solid #ccc;
    .submit-orders {
      display: inline-block;
      width: 150px;
      text-align: center;
      cursor: pointer;
      line-height: 60px;
      background: #e69b47;
      color: #fff;
      font-size: 20px;
      margin-left: 20px;
    }
  }
}
</style>
<style lang="less">
.steps-box {
  .ant-steps-item-finish .ant-steps-item-icon {
    border-color: #e69b47;
    .ant-steps-icon {
      color: #e69b47;
    }
  }
  .ant-steps-item-finish > .ant-steps-item-content > .ant-steps-item-title::after {
    background: #e69b47;
  }
  .ant-steps-item-process .ant-steps-item-icon {
    background: #e69b47;
    border-color: #e69b47;
  }
}
</style>
